/*
 * hellopanda-overlay
 */
const HELLOPANDA_OVERLAY = {
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', function() {
  
      const overlays = document.querySelectorAll('.wp-block-hellopanda-overlay-block');
      overlays.forEach(overlay => {

        const key = overlay.id || '';

        // 버튼 클릭 이벤트
        const close_btns = document.querySelectorAll(`.overlay-${key}`);
        close_btns.forEach(close_btn => {
          close_btn.addEventListener('click', () => {
            _.toggle_overlay(overlay, 'toggle');
          });
        });

        // 컨테이너 클릭 이벤트
        overlay.addEventListener('click', (e) => {
          _.click_handler(e, overlay);
        });

      });
      _.key_handler(overlays);

    });
  },
  toggle_overlay: function(container, status) {

    const active_class = 'overlay-active';
    const is_active = container.classList.contains(active_class);
    if (is_active || status === 'close') {
      container.classList.remove(active_class);
    } else {
      container.classList.add(active_class);
    }

  },
  click_handler: function(e, overlay) {

    const _ = this;
    const is_current = e.target.classList.contains('wp-block-hellopanda-overlay-item-block');
    const is_inside = e.target.closest('.wp-block-hellopanda-overlay-item-block');
    const is_close_btn = e.target.closest('.wp-block-hellopanda-overlay-close-block');

    if (is_current || !is_inside || is_close_btn) {
      _.toggle_overlay(overlay, 'close');
    }

  },
  key_handler: function(overlays) {

    if (!overlays.length) return;

    const _ = this;
    function handleKeydown(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        overlays.forEach(overlay => {
          _.toggle_overlay(overlay, 'close');
        });
      }
    }
    document.addEventListener("keydown", handleKeydown);

  }
};
HELLOPANDA_OVERLAY.init();